import { startTransition, useActionState, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import ContactTemplates from "../../contact-templates";
import { toaster } from "@/utils/toaster";
import { Button } from "@/components/ui/button";
import { useAlertTheParticipantMutation } from "@/graphql/generated";
import type { PanelProps } from "../types";

export function InSystemPanel({ patient, onClose }: PanelProps) {
  const { t } = useTranslation();
  const [selectedTemp, setSelectedTemp] = useState("");
  const [alertTheParticipant] = useAlertTheParticipantMutation();

  const templates = useMemo(
    () => [
      { id: 1727832, body: t("you_invited_to_room") },
      { id: 7135920, body: t("please_wait_for_admin_invite") },
    ],
    [t]
  );

  const [, sendAction, isSending] = useActionState(async () => {
    const msg = templates.find((item) => item.id.toString() === selectedTemp);
    if (!patient.pid || !msg?.id) {
      toaster("error", t("error"), {
        description: t("please_select_patient"),
        closeButton: true,
      });
      return null;
    }
    try {
      await alertTheParticipant({
        variables: {
          message: msg.body,
          target: patient.pid,
        },
      });
      toaster("success", t("message_sent_success"), { closeButton: true });
      onClose();
    } catch (err) {
      console.error("alertTheParticipant error:", err);
      toaster("error", t("error_occurred"), { closeButton: true });
    }
    return null;
  }, null);

  return (
    <div className="flex flex-col min-h-0 gap-4">
      <ContactTemplates
        isLoading={false}
        templates={templates}
        callBack={setSelectedTemp}
      />
      <div className="flex gap-2 w-full shrink-0">
        <Button variant="outline" className="min-w-28" onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button
          disabled={isSending}
          className="flex-1"
          onClick={() => startTransition(() => sendAction())}
        >
          {isSending ? "..." : t("send")}
        </Button>
      </div>
    </div>
  );
}
